// src/stores/routeCache.js
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useRouteCacheStore = defineStore('routeCache', () => {
  // 存储路由缓存计数
  const cacheMap = ref(new Map())

  // 获取缓存键（兼容原有接口）
  const getCacheKey = (route) => {
    const baseKey = route.meta.cacheKey || route.path.split('?')[0]
    return cacheMap.value.has(baseKey) 
      ? `${baseKey}-${cacheMap.value.get(baseKey)}` 
      : baseKey
  }

  // 刷新缓存（兼容原有接口）
  const refreshCache = (path) => {
    const baseKey = path.split('?')[0]
    cacheMap.value.set(baseKey, (cacheMap.value.get(baseKey) || 0) + 1)
  }

  return {
    getCacheKey,
    refreshCache,
    cacheMap
  }
})